import DateRangePicker from "react-bootstrap-daterangepicker";
import dayjs from "dayjs";

const PageHeader = ({
  classNames = {
    container: "",
    heading: "",
    subHeading: "",
  },
  heading,
  subHeading,
  showDateRange = false,
  startDate = "All",
  endDate = "All",
  setStartDate = () => {},
  setEndDate = () => {},
}) => {
  const startAllDate = dayjs("1970-01-01").startOf("day");
  const endAllDate = dayjs().endOf("day");

  const handleApply = (event, picker) => {
    const start = picker.startDate.format("MM/DD/YYYY");
    const end = picker.endDate.format("MM/DD/YYYY");
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div
      className={`d-md-flex align-items-start justify-content-between gap-2 mb-4 CT-page-header ${classNames.container}`}
    >
      <div>
        {heading && (
          <h4 className={`heading ${classNames.heading}`}>{heading}</h4>
        )}
        {subHeading && (
          <p className={`sub-heading ${classNames.subHeading}`}>{subHeading}</p>
        )}
      </div>
      {showDateRange && (
        <div className="date-range-box justify-content-end">
          <DateRangePicker
            initialSettings={{
              startDate:
                startDate === "All"
                  ? startAllDate.toDate()
                  : dayjs(startDate).toDate(),
              endDate:
                endDate === "All"
                  ? endAllDate.toDate()
                  : dayjs(endDate).toDate(),
              ranges: {
                All: [
                  dayjs("1970-01-01").startOf("day").toDate(),
                  dayjs().endOf("day").toDate(),
                ],
                Today: [dayjs().toDate(), dayjs().toDate()],
                Yesterday: [
                  dayjs().subtract(1, "days").toDate(),
                  dayjs().subtract(1, "days").toDate(),
                ],

                "Last 7 Days": [
                  dayjs().subtract(6, "days").toDate(),
                  dayjs().toDate(),
                ],
                "Last 30 Days": [
                  dayjs().subtract(29, "days").toDate(),
                  dayjs().toDate(),
                ],
                "This Month": [
                  dayjs().startOf("month").toDate(),
                  dayjs().endOf("month").toDate(),
                ],
                "Last Month": [
                  dayjs().subtract(1, "month").startOf("month").toDate(),
                  dayjs().subtract(1, "month").endOf("month").toDate(),
                ],
              },
              maxDate: new Date(),
            }}
            onApply={handleApply}
          >
            <input
              type="text"
              readOnly
              placeholder="Select Date Range"
              className={`daterange text-center cursor`}
              value={
                (startDate === startAllDate.format("MM/DD/YYYY") &&
                  endDate === endAllDate.format("MM/DD/YYYY")) ||
                (startDate === "All" && endDate === "All")
                  ? "Select Date Range"
                  : dayjs(startDate).format("MM/DD/YYYY") &&
                      dayjs(endDate).format("MM/DD/YYYY")
                    ? `${dayjs(startDate).format(
                        "MM/DD/YYYY",
                      )} - ${dayjs(endDate).format("MM/DD/YYYY")}`
                    : "Select Date Range"
              }
              style={{
                fontWeight: 500,
                background: "white",
                color: "rgba(0, 0, 0, 0.87)",
                fontSize: "13px",
                padding: "12px",
                borderRadius: "64px",
                border: "1px solid #FF4D67",
                height: "40px",
              }}
            />
          </DateRangePicker>
          <div className="right-drp-btn">Select Date</div>
        </div>
      )}
    </div>
  );
};

export default PageHeader;
